<template>
    <div class="settings">
        <CrmConnectionPendingFinal v-if="!isChange" />
        <template v-else>
            <v-row class="mx-0 my-10">
                <div>
                    <BotSettings :connector="connector" />
                </div>
            </v-row>
            <v-row justify="end" class="ma-0">
                <v-btn @click="goToProject" outlined class="mr-3 mt-2 cancel-btn">Завершить</v-btn>
            </v-row>
        </template>
    </div>
</template>

<script>
import BotSettings from './BotSettings.vue'
import CrmConnectionPendingFinal from '@/components/project/onBoarding/CrmConnectionPendingFinal.vue'
import { mapState } from 'vuex'
import cfg from '../../../../config'
export default {
    name: 'AltegioSettings',
    props: {
        isChange: {
            type: Boolean,
            default: false,
        },
        connector: {
            type: Object,
            default: null,
        },
    },
    components: { BotSettings, CrmConnectionPendingFinal },
    data: () => ({
        cfg,
    }),
    computed: {
        ...mapState('project', ['loggedAddingConnector']),
    },

    methods: {
        goToProject() {
            this.$parent.$emit('goToProject')
        },
    },
}
</script>
<style lang="sass" scoped>
.cancel-btn
    border-color: #0000001F !important
</style>
